import { NgModule } from '@angular/core';

import { BonsaiNodeSelectDirective } from './bonsai/bonsai-node-select.directive';
import { BonsaiTabIndexDirective } from './bonsai/bonsai-tabindex.directive';
import { StopPropagationDirective } from './stop-propagation.directive';
import { TruncateDirective } from './truncate/truncate.directive';
import { HideOnEscapeDirective } from './hide-on-escape.directive';

@NgModule({
  imports: [
    StopPropagationDirective,
    TruncateDirective,
  ],
  declarations: [
    BonsaiNodeSelectDirective,
    BonsaiTabIndexDirective,
    HideOnEscapeDirective,
  ],
  exports: [
    BonsaiNodeSelectDirective,
    BonsaiTabIndexDirective,
    StopPropagationDirective,
    HideOnEscapeDirective,
    TruncateDirective,
  ],
})
export class CommonDirectivesModule {}
